module.exports = __webpack_public_path__ + "img/logo_wabeyi.bac2e6b5.png";